import type { MediaDto } from '@/lib/sanity/dto';
import { isSvgImage, resolveImageAlt, sanityImage } from '@/lib/sanity/image';
import type { LightboxSlide } from './lightbox.types';

const FALLBACK_DIM = { width: 1200, height: 900 };

export function buildLightboxSlide(image: MediaDto): LightboxSlide {
    const asset = image.asset;
    const dim = asset?.metadata?.dimensions;
    const { width, height } = dim && dim.width > 0 && dim.height > 0 ? dim : FALLBACK_DIM;

    return {
        src: sanityImage.gallery(image) ?? asset?.url ?? '',
        width,
        height,
        alt: resolveImageAlt(image),
        // SVGs need a custom renderer to scale up (see LightboxRoot).
        isSvg: isSvgImage(image),
    };
}

/** Slides for a gallery of block media items, in render order. */
export function buildLightboxSlides(images: MediaDto[]): LightboxSlide[] {
    return images.map(buildLightboxSlide);
}
